import { createContext, useContext } from 'react';

export const CAWorkspaceContext = createContext(null);

export const CAWorkspaceProvider = ({ clientId, clientName, gstin, children }) => (
  <CAWorkspaceContext.Provider value={{ clientId, clientName, gstin }}>
    {children}
  </CAWorkspaceContext.Provider>
);

export const useCAWorkspace = () => useContext(CAWorkspaceContext);
